module.exports = __webpack_public_path__ + "static/media/21ECLAC41.6cad0e5f.jpg";